import { Navigate, Outlet } from 'react-router-dom';

import { AppSidebar } from '../components/app-sidebar';
import { SidebarInset, SidebarProvider } from '../components/shadcn/sidebar';
import { ReferenceDrawer } from '@/components/molecules/ReferenceDrawer';
import { useUserContext } from '@/Contexts/User';

export function Layout() {
  const { user } = useUserContext();

  if (!user) {
    return null;
  }

  if (!user.organisation.isGlobalAdmin) {
    return <Navigate to="/app/chronos" />;
  }

  return (
    <SidebarProvider>
      <div className="font-inter flex h-screen w-full bg-gradient-to-b from-neutral-50 from-50% via-teal-100 via-85% to-teal-200 text-sm">
        <AppSidebar />
        <ReferenceDrawer />
        <SidebarInset className="overflow-y-auto rounded-lg border border-black/10 bg-white">
          <Outlet />
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
